declare global {
    interface Window {
        config: Config;
        crm_version: string;
        crm_cdn: string;
        PDFJSWorker: any;
        translation_address: string;
        common_translation_address: string;
        common_close_captcha_js: string;
        devHost?: string;
        traceIdName?: string;
        FingerprintJS?: Function;
        _uLang?: any;
    }

    namespace Action {
        interface Sync {
            type: string;
            payload?: any;
        }

        interface AsyncCallback {
            succeeded: Function;
            failed: Function;
        }

        interface Async extends Sync {
            callback?: AsyncCallback;
        }
    }
}

// 应用配置
export class Config {
    readonly img_file = (filePath: string) => `/img${filePath}`;
    readonly js_file = (filePath: string) => `/js${filePath}`;
    readonly json_file = (filePath: string) => `/json${filePath}`;
    readonly other_file = (filePath: string) => `/other${filePath}`;
    readonly api_docs = 'https://api-document.doo.tech:12888/?inframe=1';
}

export default new Config();
